import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';

const LayoutWrapper = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  margin-bottom: 15px;
  background-color: ${({ theme }) =>
    theme.colorPalette.isDarkMode ? theme.colorPalette.grey.grey1 : theme.colorPalette.white};
`;

const LayoutColumnOne = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  padding: 20px;
`;

const LayoutColumnTwo = styled.div<{ width: number }>`
  width: ${({ width }) => width}%;
  padding: 20px;
`;

interface TwoColumnsLayoutOwnProps {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
  leftWidth?: number;
}

const TwoColumnsLayout = (props: TwoColumnsLayoutOwnProps) => {
  const { leftColumn, rightColumn, leftWidth = 65 } = props;
  return (
    <LayoutWrapper>
      <LayoutColumnOne width={leftWidth}>{leftColumn}</LayoutColumnOne>
      <LayoutColumnTwo width={100 - leftWidth}>{rightColumn}</LayoutColumnTwo>
    </LayoutWrapper>
  );
};

export default TwoColumnsLayout;
